<template>
    <div :class="[{'app-en':lang === 'en'}, 'app-canvas-wrap']">
        <Nav v-if="hadLoaded" ref="navchild"></Nav>
        <Loader :speed="loadprogress" v-if="!hadLoaded" />
        <div ref="webgl" id="webgl"></div>
        <div v-if="hadLoaded">
          <!-- logo -->
          <div class="logo">
              <a href="/"><img src="../assets/logo.png" /></a>
          </div>
          <!-- CN|EN -->
          <language @custom-event="handleChildEvent" />
          <!-- 弹框 -->
          <!-- :modal="false" 关闭遮罩层-->
          <el-dialog
            :visible.sync="dialogVisible"
            :before-close="handleClose"
            width="30%"
            :show-close="false"
            >
            <img :src="Product_introduce.image" alt="" srcset="" class="dialogimg" v-if="Product_introduce.image">
            <span v-if="Product_introduce.text && lang == 'cn'">{{Product_introduce.text}}</span>
            <span v-if="Product_introduce.text && lang == 'en'">{{Product_introduce.en_text}}</span>
          </el-dialog>
          <!-- 菜单栏 -->
          <div class="app-toolbar">
              <div class="app-toolbar-circle">
                  <div class="ring"></div>
                  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100%">
                      <g class="ring">
                          <g class="toolbar-item" @click="openLink()">
                              <path
                                  d="M 482.13602837739217 125.84452286971282 L 452.40303192456616 51.57508822842692 A 720 720 0 0 1 583.7391040605069 13.011337970850718 L 598.8792036093395 91.56563375186738 A 640 640  0 0 0 482.13602837739217 125.84452286971282 z"
                                  fill="transparent" stroke="transparent" stroke-width="0">
                              </path>
                              <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                  <textPath xlink:href="#SvgjsPath1031">官 网</textPath>
                              </text>
                              <text fill="rgba(255,255,255,0.7)" font-size="20px" x="36" v-if="lang == 'en'">
                                  <textPath xlink:href="#SvgjsPath1031">Website</textPath>
                              </text>
                          </g>
                          <g :class="[{'active':toobarActive == 'principle'}, 'toolbar-item']" @click="selectToobar('principle')">
                              <path
                                  d="M 598.8792036093395 91.56563375186738 L 583.7391040605069 13.011337970850718 A 720 720 0 0 1 720.0000000000024 0 L 720.0000000000022 80 A 640 640  0 0 0 598.8792036093395 91.56563375186738 z"
                                  fill="transparent" stroke="transparent" stroke-width="0">
                              </path>
                              <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                  <textPath xlink:href="#SvgjsPath1032">原 理</textPath>
                              </text>
                              <text fill="rgba(255,255,255,0.7)" font-size="20px" x="20" v-if="lang == 'en'">
                                  <textPath xlink:href="#SvgjsPath1032">Principle</textPath>
                              </text>
                          </g>
                          <g :class="[{'active':toobarActive == 'type'}, 'toolbar-item']" @click="selectToobar('type')">
                              <path
                                  d="M 720 80 L 720 0 A 720 720 0 0 1 856.2608959394953 13.011337970851173 L 841.1207963906625 91.56563375186772 A 640 640  0 0 0 720 80 z"
                                  fill="transparent" stroke="transparent" stroke-width="0">
                              </path>
                              <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" @mouseenter="greet" v-if="lang == 'cn'">
                                  <textPath xlink:href="#SvgjsPath1000">型 号</textPath>
                              </text>
                              <text fill="rgba(255,255,255,0.7)" font-size="20px" x="42" @mouseenter="greet" v-if="lang == 'en'">
                                  <textPath xlink:href="#SvgjsPath1000">Model</textPath>
                              </text>
                          </g>
                          <g :class="[{'active':cebanstatus == false}, 'toolbar-item']" @click="selectToobar('outer')">
                              <path
                                  d="M 841.1207963906625 91.56563375186772 L 856.2608959394953 13.011337970851173 A 720 720 0 0 1 987.5969680754358 51.57508822842772 L 957.8639716226096 125.8445228697135 A 640 640  0 0 0 841.1207963906625 91.56563375186772 z"
                                  fill="transparent" stroke="transparent" stroke-width="0">
                              </path>
                              <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                  <textPath xlink:href="#SvgjsPath1001">侧 板</textPath>
                              </text>
                              <text fill="rgba(255,255,255,0.7)" font-size="20px" x="20" v-if="lang == 'en'">
                                  <textPath xlink:href="#SvgjsPath1001">Side plate</textPath>
                              </text>
                          </g>
                      </g>
                      <defs>
                          <path id="SvgjsPath1000"
                              d="M 720 49 L 720 48 A 672 672 0 0 1 847.1768362101957 60.143915439461125 L 846.9875849658353 61.1258441367238 A 671 671  0 0 0 720 49 z">
                          </path>
                          <path id="SvgjsPath1001"
                              d="M 846.9875849658353 61.1258441367238 L 847.1768362101957 60.143915439461125 A 672 672 0 0 1 969.7571702037401 96.13674901319928 L 969.3855077480798 97.06511694621531 A 671 671  0 0 0 846.9875849658353 61.1258441367238 z">
                          </path>
                          <path id="SvgjsPath1031"
                              d="M 470.6144922519221 97.06511694621452 L 470.2428297962618 96.13674901319848 A 672 672 0 0 1 592.8231637898064 60.14391543946067 L 593.0124150341668 61.12584413672346 A 671 671  0 0 0 470.6144922519221 97.06511694621452 z">
                          </path>
                          <path id="SvgjsPath1032"
                              d="M 593.0124150341668 61.12584413672346 L 592.8231637898064 60.14391543946067 A 672 672 0 0 1 720.0000000000023 48 L 720.0000000000023 49 A 671 671  0 0 0 593.0124150341668 61.12584413672346 z">
                          </path>
                      </defs>
                  </svg>
              </div>
              <div class="app-submenu-wrap" v-if="toobarActive === 'principle'">
                      <div
                        v-for="(item,index) in upperObj"
                        :key="index"
                        :class="[{'active':upperActive === item.id}, 'app-submenu-item']"
                        @click="bisect(item)"
                      >
                      <!-- 剖面 -->
                          <template v-if="lang == 'cn'">
                              {{ item.text }}
                          </template>
                          <template v-if="lang == 'en'">
                              {{ item.en_text }}
                          </template>
                      </div>
              </div>
              <div class="app-submenu-wrap" v-if="toobarActive === 'type'">
                      <div
                        v-for="(item,index) in downObj"
                        :key="index"
                        :class="[{'active':downActive === item.id}, 'app-submenu-item']"
                        @click="changepart(item)"
                      >
                          <template v-if="lang == 'cn'">
                              {{ item.text }}
                          </template>
                          <template v-if="lang == 'en'">
                              {{ item.en_text }}
                          </template>
                      </div>
              </div>
          </div>
        </div>

        <!-- <div @click="test" class="test">测试</div> -->

    </div>
</template>

<script>
    import * as THREE from  'three';
    import TWEEN from '@tweenjs/tween.js';
    import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
    import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
    import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
    import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js'

    // import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
    // import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
    // import { OutlinePass  } from 'three/examples/jsm/postprocessing/OutlinePass.js';
    // // ShaderPass功能：使用后处理Shader创建后处理通道
    // import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
    // // FXAA抗锯齿Shader
    // import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader.js';
    // // SMAA抗锯齿通道
    // import { SMAAPass } from 'three/examples/jsm/postprocessing/SMAAPass.js';
    // // 伽玛校正后处理Shader
    // import { GammaCorrectionShader } from 'three/examples/jsm/shaders/GammaCorrectionShader';
    // import { CSS2DRenderer,CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js';
    // // 引入CSS3渲染器CSS3DRenderer
    // // import { CSS3DRenderer,CSS3DObject } from 'three/examples/jsm/renderers/CSS3DRenderer.js';

    import Loader from './Loader.vue';
    import Nav from './nav.vue';
    import language from './language.vue';

    var scene;

    export default {

        components: {
            Loader,
            Nav,
            language,
        },

        data() {
            return {
                timer: null, // 定时器
                hadLoaded: false, // 是否已加载完毕
                loadprogress: 0, // 加载进度
                modelLoaded: false, // 模型是否加载

                Clock: null, // 用于跟踪时间
                camera: null, // 相机对象
                renderer: null, // 渲染器对象
                container: null, // DOM节点
                controls: null, // 轨道控制器
                containerW: 0, // DOM宽度
                containerH: 0, // DOM高度
                model: null, //模型
                toobarActive: null, // 工具栏状态

                downhtmldimension:null, // 型号HTML标注
                downhtmldimension2:null, // 型号HTML标注
                isbisectstatus:false, //是否处于剖面状态
                dialogVisible:false, //弹窗
                mixer:null, //动画播放器
                animationlist:null,//动画集合列表
                clipAction:null, //动画对象
                is_hidenote:true,

                cebanstatus:true, //侧板状态
                Product_introduce:{
                  text:'',
                  en_text:'',
                  image:'',
                },
                downhtmldimension2_info:{ //外挡介绍
                  text:'挂钩外挡：可阻挡出料口，调节出料宽度',
                  en_text:'hook type external deckling: to adjust the product width by blocking the edges',
                  image:require('../assets/images/wd.png'),
                },
                localPlaneCommon: new THREE.Plane(new THREE.Vector3(7, 0, 0), 10.1), // 剖面
                upperActive:null,
                downActive:null,
                lang: 'cn', // 语言
                upperObj:[ //原理选项
                  {
                      id: 0,
                      text: '剖面', //菜单显示
                      en_text: 'Section view', //英文
                  },
                ],
                downObj: [ //型号选项
                  {
                      id: 0,
                      text: '45°斜阻流棒', //菜单显示
                      showtext: '45°斜阻流棒', //页面显示
                      en_text: '45° choke bar', //英文
                      modelname:"45du", //模型零件名称
                      // coordinate_list:[-72, 13.15, 14.68], //标注坐标
                      coordinate_list:null, //标注坐标
                      Product_info:{
                        text:'45°斜阻流棒产品介绍',
                        en_text: '45°-Inclined flow bar', //英文
                        image:'',
                      },
                  },
                  {
                      id: 1,
                      text: '70°斜阻流棒', //菜单显示
                      showtext: '70°斜阻流棒', //页面显示
                      en_text: '70° choke bar', //英文
                      modelname:"70du", //模型零件名称
                      // coordinate_list:[-72, 16.19, 4.96], //标注坐标
                      coordinate_list:null, //标注坐标
                      Product_info:{
                        text:'70°斜阻流棒产品介绍',
                        en_text: '70°-Inclined flow bar', //英文
                        image:'',
                      },
                  },
                ],
            }
        },

        mounted: function () {
            let _this = this;

            _this.initCanvas();

            _this.timer = setInterval(function() {
                if ( !_this.hadLoaded ) {
                    if ( _this.loadprogress < 80 ) {
                        _this.loadprogress += 0.8;
                    } else if ( _this.modelLoaded ) {
                        if ( _this.loadprogress <= 100 ) {
                            _this.loadprogress += 2;
                        } else {
                            _this.hadLoaded = true;
                            clearInterval(_this.timer);
                            _this.timer = null;
                        }
                    }
                }
            }, 20);
            this.raycasterclick()
            window.addEventListener("resize", _this.onResize, false);
            if(sessionStorage.getItem('language')){
              this.lang = sessionStorage.getItem('language'); // 存入一个值
            }else{
              sessionStorage.setItem('language',this.lang); // 存入一个值
            }
        },
        beforeDestroy(){
          let _this = this
          _this.scene.remove(_this.model)
          _this.model.traverse(function (object) {
            if (object.type === 'Mesh') {
              object.geometry.dispose()
              object.material.dispose()
            }
          })
        },
        methods: {
          greet () {},
          /**
           * @description 打开链接
           * @param {*} link
           */
          openLink: function(link) {
            if (this.lang == 'cn') {
              window.open('https://www.jc-times.com/', '_blank');
            } else {
              window.open('https://en.jc-times.com/', '_blank');
            }
          },
          /**
           * @description 相机动画
           */
          tweenCamera: function( newP, newT, callBack) {
            var _this = this
            var tween = new TWEEN.Tween({
              x1: _this.camera.position.x,
              y1: _this.camera.position.y,
              z1: _this.camera.position.z,
              x2: _this.controls.target.x,
              y2: _this.controls.target.y,
              z2: _this.controls.target.z,  // 控制点的中心点z
            });
            tween.to({
              x1: newP.x,
              y1: newP.y,
              z1: newP.z,
              x2: newT.x,
              y2: newT.y,
              z2: newT.z
            }, 1000);
            tween.onUpdate(function (object) {
              _this.camera.position.x = object.x1;
              _this.camera.position.y = object.y1;
              _this.camera.position.z = object.z1;
              _this.controls.target.x = object.x2;
              _this.controls.target.y = object.y2;
              _this.controls.target.z = object.z2;
              _this.controls.update();
            })
            tween.onComplete(function () {
              _this.controls.enabled = true;
              callBack && callBack()
            })
            tween.easing(TWEEN.Easing.Cubic.InOut);
            tween.start();
          },

          /**
           * @description 初始化Canvas
           */
          initCanvas: function() {
              let _this = this;

              _this.clock = new THREE.Clock();

              // 创建渲染器
              _this.initRenderer();

              // 创建场景
              _this.initScene();

              // 创建相机
              _this.initCamera();

              // 创建相机控制器
              _this.initControls();

              // 创建环境贴图
              _this.initPmremGenerator();

              // 加载模型
              _this.loadModel();

          },

          /**
           * @description 初始化渲染器
           */
          initRenderer: function() {
              let _this = this;

              _this.container = this.$refs.webgl;
              _this.containerW = this.$refs.webgl.getBoundingClientRect().width;
              _this.containerH = this.$refs.webgl.getBoundingClientRect().height;

              _this.renderer = new THREE.WebGLRenderer({
                  antialias: true,
                  alpha: true
              });
              _this.renderer.setSize(this.containerW,this.containerH);
              _this.renderer.localClippingEnabled = true;
              _this.renderer.clippingPlanes = Object.freeze([])
              _this.renderer.setClearAlpha(0);
              _this.renderer.setPixelRatio(window.devicePixelRatio);
              _this.renderer.outputEncoding = THREE.sRGBEncoding;
              _this.container.appendChild(_this.renderer.domElement);

          },

          /**
           * @description 初始化场景
           */
          initScene: function() {
              let _this = this;

              _this.scene = new THREE.Scene();
          },

          /**
           * @description 初始化相机
           */
          initCamera: function() {
            let _this = this;
            _this.camera = new THREE.PerspectiveCamera(45, this.containerW / this.containerH, 0.1, 10000);
            _this.camera.position.set(-132, 70, 185);
            _this.camera.lookAt(_this.scene.position);

            // 正投影相机
            // const width = window.innerWidth; //canvas画布宽度
            // const height = window.innerHeight; //canvas画布高度
            // const k = width / height; //canvas画布宽高比
            // const s = 600;//控制left, right, top, bottom范围大小
            // _this.camera = new THREE.OrthographicCamera(-s * k, s * k, s, -s, 1, 8000);
          },

          /**
           * @description 初始化相机控制器
           */
          initControls: function() {
              let _this = this;

              _this.controls = new OrbitControls(_this.camera, _this.renderer.domElement);
              _this.controls.enablePan = false;
              _this.controls.enableDamping = true;
              _this.controls.dampingFactor = 0.1;
              _this.controls.maxPolarAngle = Math.PI;
              _this.controls.minPolarAngle = 0;
              _this.controls.enablePan = false;
              _this.controls.enableZoom = true;

              _this.controls.minDistance = 120;
              _this.controls.maxDistance = 400;
          },

          /**
           * @description 初始化环境贴图
           */
          initPmremGenerator: function() {
            let _this = this;
            let pmremGenerator = new THREE.PMREMGenerator(_this.renderer);
            let loaderRGBE = new RGBELoader();
            pmremGenerator.compileEquirectangularShader()
            loaderRGBE.load('../../static/hdr/photo_studio_01_1k.hdr', texture => {
              const envMap = pmremGenerator.fromEquirectangular(texture).texture;
              _this.scene.environment = envMap;
              texture.dispose();
              pmremGenerator.dispose();
            })
          },

          /**
           * @description 加载模型文件
           */
          loadModel: function() {
              let _this = this;
              _this.textrueLoader = new THREE.TextureLoader();
              let loader = new GLTFLoader();
              loader.setMeshoptDecoder(MeshoptDecoder);
              loader.load("../../static/model/zlb/zlb.glb", function(gltf) {
                console.log(gltf,'gltf');
                _this.model = gltf.scene;
                _this.animationlist = gltf.animations
                _this.changepart(_this.downObj[0])

                _this.modelLoaded = true;
                // _this.model.position.set(0, 100, 0);
                _this.addbiaozhu() //添加标注
                _this.scene.add(_this.model);
                _this.animate();

              });
          },

          /**
           * @description 循环渲染Canvas
           */
          animate: function() {
            let _this = this;
            requestAnimationFrame(_this.animate);
            _this.controls.update();
            TWEEN.update();
            // if (_this.clippingPlanesStatus) {
            //   _this.localPlane1.constant += _this.step;
            //   _this.localPlane3.constant += 0.25;
            // }
            // 创建一个时钟对象Clock
            let mixerUpdateDelta = _this.clock.getDelta();
            if (_this.mixer !== null) {
              // 更新播放器相关的时间
              _this.mixer.update(mixerUpdateDelta);
            }
            // _this.composer.render(); // 使用处理对象渲染场景
            _this.renderer.render(_this.scene, _this.camera);
            // _this.labelRenderer.render(_this.scene, _this.camera); //渲染html标签
          },

          /**
           * @description 改变窗口大小，重新渲染Canvas
           */
          onResize: function() {
              let _this = this;
              _this.$nextTick(()=>{
                if(_this.$refs.webgl.getBoundingClientRect()){
                  _this.containerW = _this.$refs.webgl.getBoundingClientRect().width
                  _this.containerH = _this.$refs.webgl.getBoundingClientRect().height
                  _this.camera.aspect = _this.containerW / _this.containerH;
                  _this.camera.updateProjectionMatrix();
                  _this.renderer.setSize(_this.containerW, _this.containerH);
                }
              })
          },

          /**
           * @description 选择语言
           */
          selectLang: function(e) {
              let _this = this;
              _this.lang = e;
              _this.toobarActive = '';
              _this.dismantleActive = '';
              _this.assembleActive = '';
          },

          /**
           * @description 选择菜单
           * @param {String} e 菜单
           */
          selectToobar: function(e) {
            let _this = this
            if( e == 'outer'){
              if(_this.cebanstatus){
                if( _this.model.getObjectByName("45du").visible ){
                  _this.model.getObjectByName("45du_ceban").visible = false
                }else{
                  _this.model.getObjectByName("70du_ceban").visible = false
                }
                _this.cebanstatus = false
              }else{
                if( _this.model.getObjectByName("45du").visible ){
                  _this.model.getObjectByName("45du_ceban").visible = true
                }else{
                  _this.model.getObjectByName("70du_ceban").visible = true
                }
                _this.cebanstatus = true
              }
              if(_this.isbisectstatus){
                _this.bisect(this.upperObj[0])
                _this.cebanstatus = true
              }

              var newT = { //新的聚焦位置
                  x: 0,
                  y: 0,
                  z: 0,
                }
                var newP = { //新的相机位置
                  x: -160,
                  y: -20,
                  z: -20
                }
                _this.tweenCamera(newP, newT);
            }
            if ( this.toobarActive == e ) {
              this.toobarActive = '';
            }else{
              this.toobarActive = e;
              if(e == 'principle'){
                var newT = { //新的聚焦位置
                  x: 0,
                  y: 0,
                  z: 0,
                }
                var newP = { //新的相机位置
                  x: -210,
                  y: 0,
                  z: 0
                }
                _this.tweenCamera(newP, newT);
              }else if( e =='type'){
                var newT = { //新的聚焦位置
                  x: 0,
                  y: 0,
                  z: 0,
                }
                var newP = { //新的相机位置
                  x: -132,
                  y: 70,
                  z: 185
                }
                _this.tweenCamera(newP, newT);
                if(_this.isbisectstatus){
                  _this.bisect(this.upperObj[0])
                }
              }
            }

          },

          /**
           * @description 剖面
           * @param {number} e 零件型号
           */
          bisect: function(item) {
            let _this = this
            _this.upperActive = item.id;
            if(!_this.isbisectstatus){ //无剖面
              _this.model.traverse(function(child) {
                if(child.material && child.name !='downhtmldimension' && child.name !='downhtmldimension2'){
                  child.material.clippingPlanes = [_this.localPlaneCommon];  //放剖面
                  _this.model.getObjectByName("45du_ceban").visible = false
                  _this.model.getObjectByName("70du_ceban").visible = false
                  _this.cebanstatus = false
                }
              });

              _this.isbisectstatus = !_this.isbisectstatus
              _this.changepart(_this.downObj[_this.downActive],1)
              var newT = { //新的聚焦位置
                x: 0,
                y: 0,
                z: 0,
              }
              var newP = { //新的相机位置
                x: -210,
                y: 0,
                z: 0
              }
              _this.tweenCamera(newP, newT);
              _this.chaianimate()
            }else{
              _this.model.traverse(function(child) {
                if(child.material && child.name !='downhtmldimension' && child.name !='downhtmldimension2'){
                  child.material.clippingPlanes = null; //还原剖面
                  if( _this.model.getObjectByName("45du").visible ){
                    _this.model.getObjectByName("45du_ceban").visible = true
                  }else{
                    _this.model.getObjectByName("70du_ceban").visible = true
                  }
                }
              });
              _this.cebanstatus = true
              _this.upperActive = null;
              _this.isbisectstatus = !_this.isbisectstatus
              if(_this.downhtmldimension){ //移除原先的标注
                _this.model.remove(_this.downhtmldimension)
              }
              _this.downhtmldimension=null
              _this.heanimate()
            }
          },

          chaianimate(){
            let _this = this
            if(_this.clipAction){
              _this.clipAction.stop()
            }
            //包含关键帧动画的模型作为参数创建一个播放器
            _this.mixer = new THREE.AnimationMixer(_this.model);
            if(_this.downActive){ //70du
              //  获取gltf.animations[0]的第一个clip动画对象
              // console.log(_this.downActive);
              _this.clipAction = _this.mixer.clipAction(_this.animationlist[2]); //创建动画clipAction对象
            }else{ //45du
              // console.log(_this.downActive);
              _this.clipAction = _this.mixer.clipAction(_this.animationlist[0]); //创建动画clipAction对象
            }
            //0 45 chai
            //1 45 he
            //3 75 chai
            //4 75 he
            //不循环播放
            _this.clipAction.loop = THREE.LoopOnce;
            // 物体状态停留在动画结束的时候
            _this.clipAction.clampWhenFinished = true
            _this.clipAction.play(); //播放动画
          },
          heanimate(){
            let _this = this
            if(_this.clipAction){
              _this.clipAction.stop()
            }
            //包含关键帧动画的模型作为参数创建一个播放器
            _this.mixer = new THREE.AnimationMixer(_this.model);
            if(_this.downActive){ //70du
              //  获取gltf.animations[0]的第一个clip动画对象
              console.log(_this.downActive);
              _this.clipAction = _this.mixer.clipAction(_this.animationlist[3]); //创建动画clipAction对象
            }else{ //45du
              console.log(_this.downActive);
              _this.clipAction = _this.mixer.clipAction(_this.animationlist[1]); //创建动画clipAction对象
            }
            //0 45 chai
            //1 45 he
            //3 75 chai
            //4 75 he
            //不循环播放
            _this.clipAction.loop = THREE.LoopOnce;
            // 物体状态停留在动画结束的时候
            _this.clipAction.clampWhenFinished = true
            _this.clipAction.play(); //播放动画
          },

          /**
           * @description 切换零件
           * @param {Number} e 零件型号
           */
          changepart: function(item,id=0) {
            let _this = this
            _this.downActive = item.id;
            if(item.id){  //1 70
              _this.model.getObjectByName("45du").visible = false
              _this.model.getObjectByName("70du").visible = true

              _this.model.getObjectByName("骨架").visible = false //45
              _this.model.getObjectByName("骨架_001").visible = true //75

              _this.model.getObjectByName("45du_ceban").visible = false
              _this.model.getObjectByName("70du_ceban").visible = true
            }else{ //0 45
              _this.model.getObjectByName("45du").visible = true
              _this.model.getObjectByName("70du").visible = false

              _this.model.getObjectByName("骨架").visible = true //45
              _this.model.getObjectByName("骨架_001").visible = false //75

              _this.model.getObjectByName("45du_ceban").visible = true
              _this.model.getObjectByName("70du_ceban").visible = false
            }
            _this.cebanstatus = true
            if(id){
              _this.model.getObjectByName("45du_ceban").visible = false
              _this.model.getObjectByName("70du_ceban").visible = false
              _this.cebanstatus = false
            }
            var newT = { //新的聚焦位置
              x: 0,
              y: 0,
              z: 0,
            }
            var newP = { //新的相机位置
              x: -132,
              y: 70,
              z: 185
            }
            _this.tweenCamera(newP, newT);
            _this.Product_introduce = item.Product_info
            if(_this.isbisectstatus){
              //=======================================添加标注=======================================//
              if(_this.downhtmldimension){ //移除原先的标注
                _this.model.remove(_this.downhtmldimension)
              }
              if(item.coordinate_list){
                const texture = new THREE.TextureLoader().load("../../static/image/click.png");
                // console.log(texture);
                // 创建精灵材质对象SpriteMaterial
                const spriteMaterial = new THREE.SpriteMaterial({
                  color:0xff0000,//设置颜色
                  map: texture, //设置精灵纹理贴图
                });
                // 创建精灵模型对象，不需要几何体geometry参数
                // const sprite = new THREE.Sprite(spriteMaterial);
                _this.downhtmldimension = new THREE.Sprite(spriteMaterial);
                _this.downhtmldimension.scale.set(3,3);  // 标注坐标
                _this.downhtmldimension.name='downhtmldimension';  //
                _this.downhtmldimension.position.set(...item.coordinate_list);  // 标注坐标
                this.model.add(_this.downhtmldimension);
              }
              //=======================================添加标注=======================================//
            }
          },
          addbiaozhu(){
            let _this = this
            //=======================================添加标注=======================================//
            const texture = new THREE.TextureLoader().load("../../static/image/click.png");
            // 创建精灵材质对象SpriteMaterial
            const spriteMaterial = new THREE.SpriteMaterial({
              color:0xff0000,//设置颜色
              map: texture, //设置精灵纹理贴图
            });
            // 创建精灵模型对象，不需要几何体geometry参数
            // const sprite = new THREE.Sprite(spriteMaterial);
            _this.downhtmldimension2 = new THREE.Sprite(spriteMaterial);
            _this.downhtmldimension2.scale.set(3,3);  // 标注坐标
            _this.downhtmldimension2.name='downhtmldimension2';  //
            _this.downhtmldimension2.position.set(-62, -0.5,-20);  // 标注坐标
            _this.model.add(_this.downhtmldimension2);
            //=======================================添加标注=======================================//
          },
          //显示隐藏注意提示
          shownote(){
            this.is_hidenote = !this.is_hidenote
          },
          /**
           * @description 射线拾取模型
           */
          raycasterclick(){
            let _this = this
            _this.renderer.domElement.addEventListener('click', function (event) {
              // .offsetY、.offsetX以canvas画布左上角为坐标原点,单位px
              const px = event.offsetX;
              const py = event.offsetY;
              //屏幕坐标px、py转WebGL标准设备坐标x、y
              //width、height表示canvas画布宽高度
              const x = (px / event.srcElement.clientWidth) * 2 - 1;
              const y = -(py / event.srcElement.clientHeight) * 2 + 1;
              //创建一个射线投射器`Raycaster`
              const raycaster = new THREE.Raycaster();
              //.setFromCamera()计算射线投射器`Raycaster`的射线属性.ray
              // 形象点说就是在点击位置创建一条射线，射线穿过的模型代表选中
              raycaster.setFromCamera(new THREE.Vector2(x, y), _this.camera);
              // 未选中对象返回空数组[],选中一个对象，数组1个元素，选中两个对象，数组两个元素
              let intersects
              // intersects = raycaster.intersectObjects([_this.model]);
              if(_this.downhtmldimension){
                intersects = raycaster.intersectObjects([_this.downhtmldimension2,_this.downhtmldimension]);
              }else{
                intersects = raycaster.intersectObjects([_this.downhtmldimension2]);
              }
              // const intersects = raycaster.intersectObjects([_this.model]);
              // console.log("射线器返回对象", intersects);
              // intersects.length大于0说明，说明选中了模型
              if (intersects.length > 0) {
                // 声明一个三维向量用来表示某个坐标
                // const worldPosition = new THREE.Vector3();
                // 获取mesh的世界坐标，你会发现mesh的世界坐标受到父对象group的.position影响
                // intersects[0].object.getWorldPosition(worldPosition);
                // console.log('世界坐标',worldPosition);
                // console.log('本地坐标',intersects[0].object.position);
                console.log("射线器返回对象", intersects);
                if(intersects[0].object.name == 'downhtmldimension'){
                  _this.Product_introduce = {
                    text:'',
                    en_text:'',
                    image:'',
                  }
                  _this.downhtmldimension.visible = false
                  _this.dialogVisible = true
                  var oldP = { //旧的相机位置
                    x: _this.camera.position.x,
                    y: _this.camera.position.y,
                    z: _this.camera.position.z,
                  }
                  var newT = { //新的聚焦位置
                    x: intersects[0].object.position.x,
                    y: intersects[0].object.position.y,
                    z: intersects[0].object.position.z,
                  }
                  var newP = { //新的相机位置
                    x: -140,
                    y: intersects[0].object.position.y,
                    z: intersects[0].object.position.z,
                  }
                  _this.oldP = oldP
                  _this.tweenCamera(newP, newT);
                  // _this.Product_introduce = _this.downObj[_this.downActive].Product_info
                  _this.$nextTick(()=>{
                    _this.Product_introduce = _this.downObj[_this.downActive].Product_info
                  })
                }else if(intersects[0].object.name == 'downhtmldimension2'){
                  _this.Product_introduce = {
                    text:'',
                    en_text:'',
                    image:'',
                  }
                  _this.downhtmldimension2.visible = false
                  _this.dialogVisible = true
                  var oldP = { //旧的相机位置
                    x: _this.camera.position.x,
                    y: _this.camera.position.y,
                    z: _this.camera.position.z,
                  }
                  var newT = { //新的聚焦位置
                    x: intersects[0].object.position.x,
                    y: intersects[0].object.position.y,
                    z: intersects[0].object.position.z,
                  }
                  var newP = { //新的相机位置
                    x: -140,
                    y: intersects[0].object.position.y,
                    z: intersects[0].object.position.z,
                  }
                  _this.oldP = oldP
                  _this.tweenCamera(newP, newT);
                  // _this.Product_introduce = _this.downhtmldimension2_info
                  _this.$nextTick(()=>{
                    _this.Product_introduce = _this.downhtmldimension2_info
                  })
                }
              }else{
                // console.log('no select');
              }
            })
          },
          /**
           * @description 关闭弹窗
           */
          handleClose(done) {
            let _this = this
            done()
            if(_this.downhtmldimension){
              _this.downhtmldimension.visible = true
            }
            _this.downhtmldimension2.visible = true
            var newT = { //新的聚焦位置
              x: 0,
              y: 0,
              z: 0,
            }
            var newP = { //新的相机位置
              x: _this.oldP.x,
              y: _this.oldP.y,
              z: _this.oldP.z,
            }
            _this.tweenCamera(newP, newT);
          },
          handleChildEvent(){
            this.lang = sessionStorage.getItem('language')
            this.$refs.navchild.childchangelang();
          },
          /**
           * @description 测试按钮
           */
          test(){
            let _this = this
            // _this.model.traverse(function(child) {
            //   if(child.material){
            //       child.material.clippingPlanes = null
            //     }
            // });
            // _this.model.getObjectByName("mesh_0").material.transparent = true
            // _this.model.getObjectByName("mesh_0").material.opacity = 0.4
            // console.log(_this.camera.position);
            _this.scene.remove(_this.model)
            _this.model.traverse(function (object) {
              if (object.type === 'Mesh') {
                object.geometry.dispose()
                object.material.dispose()
              }
            })
            // _this.model.getObjectByName("mesh_0").visible = !_this.model.getObjectByName("mesh_0").visible //45
            // _this.model.getObjectByName("mesh_1").visible = !_this.model.getObjectByName("mesh_1").visible //45
            // _this.model.getObjectByName("骨架_001").visible = false //75

            // var tween1 = new TWEEN.Tween({number:_this.camera.fov}).to({number:15}, 1000).onUpdate(function (obj) {
            //   _this.camera.fov = obj.number
            //   _this.camera.updateProjectionMatrix();
            // }).easing(TWEEN.Easing.Cubic.Out);
            // tween1.start();
          },

        }
    }
</script>

<style scoped>
  .test{
    position: absolute;
    z-index: 10000;
    top: 0px;
    background-color: red;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
  }
  div /deep/ .el-dialog{
    position: absolute !important;
    width: 32% !important;
    right: 5% !important;
    margin-top: 35vh !important;
    border-radius: 20px !important;
  }
  div /deep/ .el-dialog span{
    font-size: 19px;
    font-weight: 700;
  }
  div /deep/ .el-dialog__header{
    padding: 0px;
  }
  .dialogimg{
    width: 100%;
    /* height: 250px; */
    object-fit: cover;
    margin-bottom: 15px;
  }
  @media (max-width:996px) {
    div /deep/ .el-dialog{
      width: 60% !important;
      margin-top: 4vh !important;
    }
  }
  @media (max-width:450px) {
    div /deep/ .el-dialog{
      width: 90% !important;
      margin-top: 4vh !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/zlbmodel.vue